/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDataFetchIndicator } from '..';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.PushToCardMapResponse, (_params: vp.LinkPushToCardMapRequest) => void, () => void];

function usePostLinkPushToCardRequest({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.LinkPushToCardMapRequest>();
  const [response, setResponse] = useState<vp.PushToCardMapResponse>({
    Success: false,
    ErrorMessage: '',
    PushToCardDetails: {
      CardToken: '',
      IframeUrl: '',
    },
  });

  useEffect(() => {
    const sendRequest = async (requestParams: vp.LinkPushToCardMapRequest) => {
      setDataFetchingInfo(true, `${t('addingCreditCard')}`, 'fullScreen');
      const res = await api.postLinkPushToCardRequest(requestParams, source);

      setResponse(res);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.LinkPushToCardMapRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        PushToCardDetails: {
          CardToken: '',
          IframeUrl: '',
        },
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostLinkPushToCardRequest);
